exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips_iIG9rtpB {\n  font-size: 0.346667rem;\n  color: #999;\n  letter-spacing: 0;\n  text-align: justify;\n  padding: 0.266667rem 0;\n}", ""]);

// exports
exports.locals = {
	"tips": "tips_iIG9rtpB"
};